<template>
    <div class="search-result-list">
        <virtual-list id="RecordSearchList" class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="searchResultList"
            :data-component="itemComponent"
            :estimate-size="50"
            :item-class="'com-record-item-w90'" />
    </div>
</template>

<script>
import FamousChooseRecordItem from '../../components/famouspedia/FamousChooseRecordItem.vue'
export default {
    name: 'RecordSearchList',
    computed: {
        searchResultList() {
            return this.$store.state.search.searchResultList;
        },
    },
    data() {
        return {
            itemComponent: FamousChooseRecordItem
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initItemComponent();
        }, 20);
    },
    methods: {
        initDom() {
            var barDom = document.getElementsByClassName('record-choose-bar')[0],
                titleDom = document.getElementsByClassName('layout-rl-title')[0],
                listDom = document.getElementById('RecordSearchList');
            if(listDom && barDom && titleDom) {
                listDom.style.height = (innerHeight - barDom.clientHeight - titleDom.clientHeight) + 'px';
            }
        },
        initItemComponent() {
            // 会根据条件来区分不同的元素
            this.itemComponent = FamousChooseRecordItem;
        },
    }
}
</script>